module.exports = __webpack_public_path__ + "static/img/slide_10.49473b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/slider/slide_10.png
// module id = DeNq
// module chunks = 0